import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";

function MediaCommunityCard({ videos, categories }) {
  const handleWatchVideos = () => {
    console.log("Watch videos");
  };

  const handleBrowseArchive = () => {
    console.log("Browse archive");
  };

  return (
    <Card
      sx={(theme) => ({
        height: "100%",
        borderRadius: theme.borders.borderRadius.lg,
        boxShadow: theme.boxShadows.md,
        backgroundColor: theme.functions.rgba(theme.palette.background.default, 0.8),
      })}
    >
      <MDBox p={3}>
        {/* SBI Faces Section */}
        <MDBox mb={4}>
          <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <MDBox display="flex" alignItems="center">
              <Icon sx={{ fontSize: "1.5rem", mr: 1, color: "text" }}>video_library</Icon>
              <MDTypography variant="h5" fontWeight="bold" color="dark">
                SBI Faces
              </MDTypography>
            </MDBox>
            <MDButton
              variant="outlined"
              color="info"
              size="small"
              onClick={handleWatchVideos}
            >
              Watch Videos
            </MDButton>
          </MDBox>
          <MDTypography variant="body2" color="text" mb={2}>
            Patient experiences
          </MDTypography>

          {videos && videos.length > 0 ? (
            <Grid container spacing={1.5}>
              {videos.slice(0, 6).map((video) => (
                <Grid item xs={6} sm={4} md={3} key={video.id}>
                  <MDBox
                    position="relative"
                    borderRadius="md"
                    overflow="hidden"
                    sx={{
                      cursor: "pointer",
                      transition: "transform 0.2s ease",
                      "&:hover": {
                        transform: "scale(1.05)",
                      },
                    }}
                  >
                    <MDBox
                      component="img"
                      src={video.thumbnail}
                      alt={video.title}
                      width="100%"
                      sx={{
                        aspectRatio: "16/9",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                    <MDBox
                      position="absolute"
                      bottom={0}
                      left={0}
                      right={0}
                      p={1}
                      sx={{
                        background: "linear-gradient(to top, rgba(0,0,0,0.7), transparent)",
                        borderRadius: "0 0 8px 8px",
                      }}
                    >
                      <MDTypography variant="caption" color="white" fontWeight="bold" noWrap>
                        {video.title}
                      </MDTypography>
                      <MDBox display="flex" alignItems="center" gap={0.5} mt={0.25}>
                        <Icon sx={{ fontSize: "0.75rem", color: "white" }}>play_circle</Icon>
                        <MDTypography variant="caption" color="white" fontSize="0.65rem">
                          {video.duration}
                        </MDTypography>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </Grid>
              ))}
            </Grid>
          ) : (
            <MDBox textAlign="center" py={3}>
              <Icon sx={{ fontSize: "3rem", color: "text", mb: 1 }}>video_library</Icon>
              <MDTypography variant="body2" color="text">
                No videos available
              </MDTypography>
            </MDBox>
          )}
        </MDBox>

        {/* VCI Media Archive Section */}
        <MDBox>
          <MDBox display="flex" alignItems="center" justifyContent="space-between" mb={2}>
            <MDBox display="flex" alignItems="center">
              <Icon sx={{ fontSize: "1.5rem", mr: 1, color: "text" }}>archive</Icon>
              <MDTypography variant="h5" fontWeight="bold" color="dark">
                SBI VCI Media Archive
              </MDTypography>
            </MDBox>
            <MDButton
              variant="outlined"
              color="info"
              size="small"
              onClick={handleBrowseArchive}
            >
              Browse Archive
            </MDButton>
          </MDBox>

          <MDBox display="flex" flexWrap="wrap" gap={1}>
            {categories.map((category, index) => (
              <Chip
                key={index}
                label={category}
                size="small"
                sx={{
                  backgroundColor: index === 0 ? "#1a4d4d" : "#E0E0E0",
                  color: index === 0 ? "white" : "#1a4d4d",
                  fontWeight: index === 0 ? "bold" : "medium",
                  cursor: "pointer",
                  transition: "all 0.2s ease",
                  "&:hover": {
                    backgroundColor: "#1a4d4d",
                    color: "white",
                  },
                }}
              />
            ))}
          </MDBox>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default MediaCommunityCard;
